// vault-listen-falten.js — Bullets in der Vault-Vorschau auf- und zuklappen.
//
// Obsidian klappt Listenpunkte mit Unterpunkten per Pfeil am Rand zusammen;
// die Vorschau zeigte sie bisher immer vollständig. Ein Punkt mit Unterliste
// bekommt hier einen Pfeil davor, ein Klick schaltet `eingeklappt` an der
// `li` um (das Verstecken der Unterliste macht die CSS-Regel).

const FALTER = 'vault-listen-falter';

function falterBauen(li) {
  const knopf = document.createElement('button');
  knopf.type = 'button';
  knopf.className = FALTER;
  knopf.setAttribute('aria-expanded', 'true');
  knopf.setAttribute('aria-label', 'Unterpunkte ein- oder ausklappen');
  knopf.textContent = '▾';
  knopf.addEventListener('click', (ev) => {
    ev.preventDefault();
    ev.stopPropagation();
    umschalten(li);
  });
  return knopf;
}

export function umschalten(li) {
  const zu = li.classList.toggle('eingeklappt');
  const knopf = li.querySelector(`:scope > .${FALTER}`);
  if (knopf) {
    knopf.textContent = zu ? '▸' : '▾';
    knopf.setAttribute('aria-expanded', String(!zu));
  }
  return zu;
}

// Jede `li` mit eigener Unterliste bekommt einen Pfeil. Mehrfach aufgerufen
// (neue Notiz im selben Container) legt sie keinen zweiten an.
export function listenFaltbarMachen(wurzel) {
  if (!wurzel) return 0;
  const punkte = wurzel.querySelectorAll('li');
  let gefaltet = 0;
  punkte.forEach((li) => {
    const hatUnterliste = Array.from(li.children).some(
      (k) => k.tagName === 'UL' || k.tagName === 'OL'
    );
    if (!hatUnterliste || li.querySelector(`:scope > .${FALTER}`)) return;
    li.classList.add('faltbar');
    li.insertBefore(falterBauen(li), li.firstChild);
    gefaltet += 1;
  });
  return gefaltet;
}
